var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resorts-filter-wrapper"},[_c('resort-filter',{attrs:{"takenResorts":_vm.resortsInSearch,"popularityResorts":_vm.popularResorts,"othersResorts":_vm.otherResorts,"nameCountryResort":_vm.nameCountryResorts},on:{"change":_vm.selectedResorts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }